import React, { useEffect, useState } from 'react';
import { useUser } from '@/shared/providers/user-provider/use-user';

function JackpotGameWidget() {
  // const [currency, setCurrency] = useState<string>();
  const { user } = useUser();

  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'module';
    // script.src = '/components/jackpot-iife.js';
    script.src = '/jackpot-components/components/jackpot-iife.js';
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  // useEffect(() => {
  //   setCurrency(user.currency ?? 'USD');
  // }, [user.currency]);

  const getCurrency = user.currency ?? 'USD';

  const getJackpotUrl = (): string => {
    const isDevelop = process.env.NODE_ENV === 'development';
    const oid = isDevelop ? 9 : 6;
    return isDevelop
      ? `wss://test.loto-million.com/jackpot/${oid}?currency=${getCurrency}`
      : `wss://vamos-games.info/jackpot/${oid}?currency=${getCurrency}`;
  };

  return (
    <vamos-jackpot-game
      url={getJackpotUrl()}
      currency={getCurrency}
    ></vamos-jackpot-game>
  );
}

export default JackpotGameWidget;
